import React from 'react';
import { createRoot } from "react-dom/client";
import './css/index.scss';
import 'react-image-gallery/styles/css/image-gallery.css';
import { BrowserRouter } from "react-router-dom";
import AppRouter from './AppRouter';
import { MotionConfig } from "framer-motion";

const root = createRoot(document.getElementById('root'));

const params = new URLSearchParams(window.location.search)
const motionParam = params.get('motion')

// Optional: allow forcing motion on/off via query param (default: respect OS setting)
const reducedMotion =
  motionParam === 'on' ? 'never' : motionParam === 'off' ? 'always' : 'user'

root.render(
    <BrowserRouter>
  <React.StrictMode>
    <MotionConfig reducedMotion={reducedMotion}>
      <AppRouter />
    </MotionConfig>
  </React.StrictMode>
    </BrowserRouter>,
);


